import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Icon from "react-icons-kit";
import { basic_compass } from "react-icons-kit/linea/basic_compass";
import { basic_smartphone } from "react-icons-kit/linea/basic_smartphone";
import { basic_mail } from "react-icons-kit/linea/basic_mail";
import { basic_world } from "react-icons-kit/linea/basic_world";
import { creditCard } from "react-icons-kit/feather/creditCard";
import { thumbsUp } from "react-icons-kit/feather/thumbsUp";
import { image } from "react-icons-kit/feather/image";
import { filePlus } from "react-icons-kit/feather/filePlus";
import OrganizationHeader from "./reusable/OrganizationHeader";

const OrganizationHome = ({
  orgName,
  orgObj,
  setOrgObj,
  userData,
  setLoggedInUserData,
  setLoadings,
  pledgesArray,
}) => {
  // translation
  const { t } = useTranslation();

  // navigate
  const navigate = useNavigate();

  // selector btns
  const [step, setStep] = useState("services");

  // services
  const services = [
    {
      id: 1,
      title: "OrganizationDetails.donation",
      icon: creditCard,
      isDisabled: true,
    },
    {
      id: 2,
      title: "OrganizationDetails.pledge",
      icon: thumbsUp,
      isDisabled: false,
    },
    {
      id: 3,
      title: "OrganizationDetails.registration",
      icon: filePlus,
      isDisabled: true,
    },
    {
      id: 4,
      title: "OrganizationDetails.media_center",
      icon: image,
      isDisabled: true,
    },
  ];

  // service box click
  const handleServiceClick = (obj) => {
    if (obj.id === 2) {
      if (!pledgesArray) {
        setLoadings(true);
      }
      navigate(`/sites/${orgName}/pledges`);
    }
  };

  // scroll to top
  useEffect(() => {
    document.querySelector(".home-content")?.scrollTo(0, 0);
  }, []);

  return (
    <div className="cards-container single-card">
      <div className="custom-card single-card">
        <OrganizationHeader
          userData={userData}
          setLoggedInUserData={setLoggedInUserData}
          orgObj={orgObj}
          setOrgObj={setOrgObj}
        />

        <div className="campaigns-or-contact">
          <button
            type="button"
            onClick={() => setStep("services")}
            className={`selector-btns${step === "services" ? " active" : ""}`}
          >
            {t("OrganizationDetails.services").toUpperCase()}
          </button>
          <button
            type="button"
            onClick={() => setStep("contact")}
            className={`selector-btns${step === "contact" ? " active" : ""}`}
          >
            {t("OrganizationDetails.contact")}
          </button>
        </div>

        {step === "services" && (
          <>
            <div className="campaign-msg">
              {t("OrganizationDetails.select_a_service")}
            </div>

            <div className="services-wrapper">
              {services.map((service) => (
                <div
                  key={service.id}
                  className="pledge-card service"
                  onClick={() => handleServiceClick(service)}
                  style={{
                    cursor: service.isDisabled ? "not-allowed" : "pointer",
                  }}
                >
                  <div style={{ marginBottom: "20px", color: "#007c16" }}>
                    <Icon icon={service.icon} size={100} />
                  </div>
                  <div className="service-title">{t(service.title)}</div>
                </div>
              ))}
            </div>
          </>
        )}

        {step === "contact" && (
          <div className="contact-box">
            <h3 className="get-in-touch-heading">
              {t("OrganizationDetails.get_in_touch")}
            </h3>
            <div className="contact-info-box">
              {/* name */}
              <h6>{orgObj.name}</h6>
              {/* streetAddress and unit no */}
              <div className="p-row">
                <div>
                  <Icon icon={basic_compass} size={16} />
                </div>
                <div className="p-row-text">
                  {orgObj.streetAddress} {orgObj.unitNumber}
                </div>
              </div>
              {/* city province and postal code */}
              <div className="p-row">
                <div className="empty-div"></div>
                <div className="p-row-text">
                  {orgObj.city} {orgObj.provinceState} {orgObj.postalZipCode}
                </div>
              </div>
              {/* country */}
              <div className="p-row">
                <div className="empty-div"></div>
                <div className="p-row-text">{orgObj.country}</div>
              </div>
              {/* phone */}
              <div className="p-row">
                <div>
                  <Icon icon={basic_smartphone} size={16} />
                </div>
                <div className="p-row-text">{orgObj.phone}</div>
              </div>
              {/* email */}
              <div className="p-row" style={{ overflow: "hidden" }}>
                <div>
                  <Icon icon={basic_mail} size={16} />
                </div>
                <div className="p-row-text">
                  {orgObj.email ? (
                    <a href={`mailto:${orgObj.email}`}>{orgObj.email}</a>
                  ) : (
                    <span>{t("Content.not_available")}</span>
                  )}
                </div>
              </div>
              {/* website */}
              <div className="p-row" style={{ overflow: "hidden" }}>
                <div>
                  <Icon icon={basic_world} size={16} />
                </div>
                <div className="p-row-text">
                  {orgObj.website ? (
                    <a href={orgObj.website} target="blank">
                      {orgObj.website}
                    </a>
                  ) : (
                    <span>{t("Content.not_available")}</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OrganizationHome;
